import { createTRPCProxyClient } from '@trpc/client';
import type { AppRouter } from '../server/api/root.ts';
import { getTRPCClientConfig } from './api';

const trpcClient = createTRPCProxyClient<AppRouter>(getTRPCClientConfig());

export { trpcClient };
